import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token automatically for write endpoints
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers["X-Admin-Token"] = token;
  }
  return config;
});

// Proxy customer-assets & amazon media URLs through our backend to bypass ad-blockers & CORP.
const PROXY_HOSTS = new Set([
  "customer-assets.emergentagent.com",
  "customer-assets-4nw71qhi.emergentagent.net",
  "m.media-amazon.com",
  "images-eu.ssl-images-amazon.com",
  "images-na.ssl-images-amazon.com",
]);

export function safeImageUrl(url) {
  if (!url) return url;
  try {
    const u = new URL(url);
    if (PROXY_HOSTS.has(u.hostname)) {
      return `${API}/img?url=${encodeURIComponent(url)}`;
    }
    return url;
  } catch {
    return url;
  }
}
